module.exports = __webpack_public_path__ + "static/media/tools-recruiting.f68e0acd.png";